import { getXrplClient } from './client'
import { XrplCurrency } from './types'

const isAccountNotFound = (error: any) => {
  const message = error?.message || error?.data?.error_message || ''
  const code = error?.data?.error
  return code === 'actNotFound' || /account not found/i.test(message)
}

export const fetchBalance = async (account: string, currency: XrplCurrency) => {
  const client = await getXrplClient()

  if (currency.isNative || currency.currency === 'XRP') {
    try {
      return await client.getXrpBalance(account)
    } catch (error) {
      if (isAccountNotFound(error)) {
        return '0'
      }
      throw error
    }
  }

  if (!currency.issuer) {
    throw new Error(`Missing issuer for ${currency.symbol}`)
  }

  let response
  try {
    response = await client.request({
      command: 'account_lines',
      account,
    })
  } catch (error) {
    if (isAccountNotFound(error)) {
      return '0'
    }
    throw error
  }

  const line = response.result.lines.find(
    (item) => item.currency === currency.currency && item.account === currency.issuer,
  )

  return line?.balance || '0'
}

export const fetchTrustlines = async (account: string) => {
  const client = await getXrplClient()
  try {
    const response = await client.request({
      command: 'account_lines',
      account,
    })
    return response.result.lines
  } catch (error) {
    if (isAccountNotFound(error)) {
      return []
    }
    throw error
  }
}
